import apiUrl from "../../../../../utils/settings";

export const registerNotificationTokenUrl = (token) => {
  return apiUrl + `/user-notifications/add-new-token?token_string=${token}`;
};